import { render, staticRenderFns } from "./ColourPicker.vue?vue&type=template&id=55e974aa&"
import script from "./ColourPicker.vue?vue&type=script&lang=ts&"
export * from "./ColourPicker.vue?vue&type=script&lang=ts&"
import style0 from "./ColourPicker.vue?vue&type=style&index=0&id=55e974aa&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports